import { useState } from 'react';

const PHOTOS = [
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/78603ec7fe11d472a015d61cc1704daa.jpeg',
    alt: 'Кованые распашные ворота с калиткой и забором',
    caption: 'Распашные ворота с кованым забором и калиткой',
  },
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/319212bcc422626d0e6733f0deef14ac.jpeg',
    alt: 'Кованые ворота с забором у кирпичного дома',
    caption: 'Ворота с кованым забором — монтаж завершён',
  },
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/0f0625efcb2fc8db679521c3d7688c1f.jpeg',
    alt: 'Ажурные кованые распашные ворота — крупный план',
    caption: 'Распашные ворота — ажурный узор ручной ковки',
  },
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/be0be01fc6b18125a0b93cf373fb9cef.jpeg',
    alt: 'Ворота с красным профлистом и кованым узором',
    caption: 'Ворота с красным профлистом и кованым декором',
  },
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/11e82b9c670986629b846ad9dafa5e9a.jpeg',
    alt: 'Ворота с красным профлистом и навесом над въездом',
    caption: 'Ворота с профлистом, кованым узором и навесом',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/8f30f5ab-b237-4c6c-ba7f-83f851b11a2d_compressed_photo_2026-07-27-18.08.04.webp',
    alt: 'Ворота с красным поликарбонатом и кованым навесом',
    caption: 'Ворота с поликарбонатом и навесом над въездом',
  },
];

export default function GallerySection() {
  const [lightbox, setLightbox] = useState<number | null>(null);

  const prev = () =>
    setLightbox((p) => (p === null ? null : p === 0 ? PHOTOS.length - 1 : p - 1));
  const next = () =>
    setLightbox((p) => (p === null ? null : p === PHOTOS.length - 1 ? 0 : p + 1));

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1400px' }}>
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Наши работы
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Реальные ворота и калитки, изготовленные и&nbsp;смонтированные нашей командой
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
          {/* Первое фото — большое */}
          <div
            className="col-span-2 relative overflow-hidden rounded-lg cursor-pointer group"
            style={{ aspectRatio: '16/7' }}
            onClick={() => setLightbox(0)}
          >
            <img
              src={PHOTOS[0].src}
              alt={PHOTOS[0].alt}
              className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-400"></div>
            <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <p className="text-background-50 text-sm font-medium">{PHOTOS[0].caption}</p>
            </div>
          </div>

          {/* Остальные фото */}
          {PHOTOS.slice(1).map((photo, idx) => (
            <div
              key={photo.src}
              className="relative overflow-hidden rounded-lg cursor-pointer group"
              style={{ aspectRatio: '4/3' }}
              onClick={() => setLightbox(idx + 1)}
            >
              <img
                src={photo.src}
                alt={photo.alt}
                className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <p className="text-background-50 text-xs font-medium">{photo.caption}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-10">
          <a
            href="https://max.ru/u/f9LHodD0cOICoHyOC2LT2Vx_42oC8Zdm2VV9Uv5O-6mGvkZgeZzUcJQkER0"
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm px-7 py-3.5 rounded-md transition-all duration-300 hover:scale-[1.03] cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-chat-3-line text-base"></i>
            </span>
            Хочу такие же — обсудить проект
          </a>
        </div>
      </div>

      {/* Lightbox */}
      {lightbox !== null && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/85 backdrop-blur-sm"
          onClick={() => setLightbox(null)}
        >
          <button
            onClick={(e) => { e.stopPropagation(); prev(); }}
            className="absolute left-4 md:left-8 w-10 h-10 flex items-center justify-center bg-background-50/10 hover:bg-background-50/25 text-background-50 rounded-full transition-all duration-300 cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-xl"></i>
          </button>

          <div
            className="relative max-w-4xl w-full mx-4 md:mx-16"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={PHOTOS[lightbox].src}
              alt={PHOTOS[lightbox].alt}
              className="w-full max-h-[80vh] object-contain rounded-lg"
            />
            <p className="text-background-50/80 text-sm text-center mt-3">
              {PHOTOS[lightbox].caption}
            </p>
            <span className="absolute top-3 right-3 text-background-50/60 text-xs">
              {lightbox + 1} / {PHOTOS.length}
            </span>
          </div>

          <button
            onClick={(e) => { e.stopPropagation(); next(); }}
            className="absolute right-4 md:right-8 w-10 h-10 flex items-center justify-center bg-background-50/10 hover:bg-background-50/25 text-background-50 rounded-full transition-all duration-300 cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-xl"></i>
          </button>

          <button
            onClick={() => setLightbox(null)}
            className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center bg-background-50/10 hover:bg-background-50/25 text-background-50 rounded-full transition-all duration-300 cursor-pointer"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>
      )}
    </section>
  );
}